import React from 'react';
import { Container } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import image from '../../assets/images/it_care_image.png';
import circle1 from '../../assets/images/it_care_circle-1.png';
import circle2 from '../../assets/images/it_care_circle-2.png';
import arrow from '../../assets/images/Arrow 1.png';

function It_solution() {
  const navigate = useNavigate();

  const handleRequestDemoClick = () => {
    navigate('/contactus', { state: { scrollToForm: true } });
  };

  return (
    <section>
      <div className='it_solution position-relative overflow-hidden py-5' style={{ background: 'var(--bg-light)' }}>
        <Container>
          <div className="modern-card border-0 p-5 position-relative overflow-hidden" data-aos="fade-up" style={{ background: 'linear-gradient(135deg, rgba(0,129,197,0.05) 0%, rgba(49,191,241,0.05) 100%)' }}>
            <div className="row align-items-center position-relative" style={{ zIndex: 1 }}>
              <div className="col-lg-7 col-md-7 col-sm-12 text-md-start text-center mb-4 mb-md-0" data-aos="fade-right" data-aos-delay="100">
                <div className='banner-badge mb-3'>
                  <span>IT SOLUTIONS</span>
                </div>
                <h1 className="display-4 fw-bold mb-3">
                  We Care Your Any<br />
                  <span className="gradient-text">IT Solution</span>
                </h1>
                <p className="lead text-muted mb-4" style={{ maxWidth: '500px' }}>
                  Proactively coordinate quality vectors vis-a-vis supply chains. 
                  Quickly engage client-centric web services to propel your business forward.
                </p>
                <div className="d-flex align-items-center justify-content-md-start justify-content-center gap-3">
                  <button className='modern-btn primary border-0' onClick={handleRequestDemoClick}>
                    Request for Demo
                  </button>
                  <img src={arrow} className="d-none d-sm-block" style={{ width: '40px', opacity: 0.6 }} alt="arrow" />
                </div>
              </div>
              <div className="col-lg-5 col-md-5 col-sm-12 position-relative text-center" data-aos="fade-left" data-aos-delay="200">
                <img src={circle2} className='position-absolute' style={{ top: '-10%', right: '10%', width: '50px', animation: 'spin 10s linear infinite' }} alt="circle decoration" />
                <img src={image} className='img-fluid rounded-4 shadow-lg hover-scale transition-smooth' style={{ transform: 'translateY(-10px)' }} alt="it solution" />
                <img src={circle1} className='position-absolute' style={{ bottom: '-10%', left: '10%', width: '50px', animation: 'spin-reverse 12s linear infinite' }} alt="circle decoration" />
              </div>
            </div>
            
            {/* Background Decorations */}
            <div className="position-absolute top-0 end-0 p-5 opacity-25" style={{ zIndex: 0 }}>
              <div className="rounded-circle" style={{ width: '300px', height: '300px', background: 'radial-gradient(var(--primary-color), transparent 70%)', filter: 'blur(40px)' }}></div>
            </div>
          </div>
        </Container>
      </div>
    </section>
  );
}

export default It_solution;
